import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { paginationSettings } from '../constants';
import i18next from "../i18n";
export class Pagination extends Component {
    static propTypes = {
        page: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        pageCount: PropTypes.number.isRequired,
        handleChangePage: PropTypes.func,
        handlePageSelected: PropTypes.func,
        handleChangePageSize: PropTypes.func,
        handleChangeSel: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            page: this.props.page,
            pageSize: this.props.pageSize,
            keyIndex: 1
        };
        this.handlePageSelected = this.handlePageSelected.bind(this);
        this.handleChangePageSize = this.handleChangePageSize.bind(this);
        this.handleChangeSel = this.handleChangeSel.bind(this);
        this.getPageItems = this.getPageItems.bind(this);
    }
    componentDidUpdate() {
        if (this.state.page !== this.props.page) {
            this.setState({
                page: this.props.page,
                pageSize: this.props.pageSize,
                keyIndex: this.state.keyIndex + 1
            });
        }
    }
    handleChangeSel(event) {
        this.handleChangePageSize(event.target.value);
    };
    render() {
        let items = this.getPageItems();
        if (this.props.allCount >= 0) {
            var firtNumber = this.state.pageSize * ((this.state.page > 0 ? this.state.page : 1) - 1) + 1;
            if (this.props.allCount === 0)
                firtNumber = 0;
            var lastNumber = firtNumber;
            if (this.state.page !== this.props.pageCount)
                lastNumber += this.state.pageSize - 1;
            else
                lastNumber = this.props.allCount;
        }
        return (
            <nav className="pagintion-main" key={this.state.keyIndex}>
                {items.length > 1 ?
                    <ul className="cofco-pagination">
                        <li className="page-item arr-left">
                            <a onClick={() => this.handlePageSelected(this.state.page - 1)}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.9732 6.95091H3.50393L8.51468 1.8056C8.91513 1.3944 8.91513 0.719604 8.51468 0.308402C8.11423 -0.102801 7.46735 -0.102801 7.0669 0.308402L0.300337 7.25667C-0.100112 7.66787 -0.100112 8.33212 0.300337 8.74333L7.0669 15.6916C7.46735 16.1028 8.11423 16.1028 8.51468 15.6916C8.91513 15.2804 8.91513 14.6161 8.51468 14.2049L3.50393 9.05964H14.9732C15.5379 9.05964 16 8.58517 16 8.00527C16 7.42537 15.5379 6.95091 14.9732 6.95091Z" fill="black" fillOpacity="0.6" />
                                </svg>
                            </a>
                        </li>
                        {items.map((item) => (
                            item
                        ))}
                        <li className="page-item arr-right">
                            <a onClick={() => this.handlePageSelected(this.state.page + 1)}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.02679 6.95091H12.4961L7.48532 1.8056C7.08487 1.3944 7.08487 0.719604 7.48532 0.308402C7.88577 -0.102801 8.53265 -0.102801 8.9331 0.308402L15.6997 7.25667C16.1001 7.66787 16.1001 8.33212 15.6997 8.74333L8.9331 15.6916C8.53265 16.1028 7.88577 16.1028 7.48532 15.6916C7.08487 15.2804 7.08487 14.6161 7.48532 14.2049L12.4961 9.05964H1.02679C0.462057 9.05964 0 8.58517 0 8.00527C0 7.42537 0.462057 6.95091 1.02679 6.95091Z" fill="black" fillOpacity="0.6" />
                                </svg>

                            </a>
                        </li>
                    </ul>
                    : ""}
                <div className="pagintion-group">
                    <span>{i18next.t("onPage")}</span>
                    <FormControl className="SelMob pagination-select">
                        <Select
                            value={this.state.pageSize}
                            onChange={this.handleChangeSel}
                        >
                            {paginationSettings.paginationTemplates.map(item =>
                                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    {this.props.allCount >= 0 &&
                        <span>{firtNumber}-{lastNumber} {i18next.t("from2")} {this.props.allCount}</span>
                    }
                </div>
            </nav>
        );
    }
    getPageItems() {
        let items = [];
        let buttonsCount = paginationSettings.buttonsCount;
        let allCount = this.props.pageCount;
        let current = this.state.page;
        let leftRangeAdded = false;
        let leftRightCount = Math.floor((buttonsCount - 4) / 2);
        items.push(<li key={1} className={"page-item " + (1 === current ? "active" : "")}><a onClick={() => this.handlePageSelected(1)}>{1}</a></li>);
        if (current > (buttonsCount + 1) / 2 && allCount > buttonsCount) {
            if (current + leftRightCount + 2 >= allCount) {
                let addedCount = buttonsCount - (2 + 2 * leftRightCount + 1 + (allCount - (current + leftRightCount)));
                if (addedCount > 0) {
                    items.push(<li key={current - leftRightCount - addedCount - 1} className="page-item range-page-item"><a onClick={() => this.handlePageSelected(current - leftRightCount - addedCount - 1)}>...</a></li>);
                    leftRangeAdded = true;
                    for (var i = addedCount; i > 0; i--) {
                        let index = current - leftRightCount - i;
                        items.push(
                            <li key={index} className={"page-item " + (index === current ? "active" : "")}><a onClick={() =>
                                this.handlePageSelected(index)}>{index}</a></li>);
                    }
                }
            }
            if (!leftRangeAdded) {
                leftRangeAdded = true;
                items.push(<li key={current - leftRightCount - 1} className="page-item range-page-item"><a onClick={() => this.handlePageSelected(current - leftRightCount - 1)}>...</a></li>);
            }
        }
        if (leftRangeAdded) {
            for (let i = current - leftRightCount; i <= Math.min(current + leftRightCount, allCount); i++) {
                items.push(
                    <li key={i} className={"page-item " + (i === current ? "active" : "")}><a onClick={() => this
                        .handlePageSelected(i)}>{i}</a></li>);
            }
            if (current + leftRightCount + 2 >= allCount) {
                for (let i = current + leftRightCount + 1; i <= allCount; i++) {
                    items.push(
                        <li key={i} className={"page-item " + (i === current ? "active" : "")}><a onClick={() => this
                            .handlePageSelected(i)}>{i}</a></li>);
                }
            } else {
                let number = Math.min(current + leftRightCount, allCount) + 1;
                items.push(<li key={number} className="page-item range-page-item"><a onClick={() => this.handlePageSelected(number)}>...</a></li>);
                items.push(<li key={allCount} className={"page-item " + (allCount === current ? "active" : "")}><a onClick={() => this.handlePageSelected(allCount)}>{allCount}</a></li>);
            }
        } else {
            for (let i = items.length + 1; i <= Math.min(buttonsCount - 2, allCount); i++) {
                items.push(
                    <li key={i} className={"page-item " + (i === current ? "active" : "")}><a onClick={() => this
                        .handlePageSelected(i)}>{i}</a></li>);
            }
            if (items.length < allCount) {
                if (items.length + 2 >= allCount) {
                    for (let i = items.length + 1; i <= Math.min(buttonsCount, allCount); i++) {
                        items.push(
                            <li key={i} className={"page-item " + (i === current ? "active" : "")}><a onClick={() => this
                                .handlePageSelected(i)}>{i}</a></li>);
                    }
                } else {
                    let number = Math.min(buttonsCount - 2, allCount) + 1;
                    items.push(<li key={number} className="page-item range-page-item"><a onClick={() => this.handlePageSelected(number)}>...</a></li>);
                    items.push(<li key={allCount} className={"page-item " + (allCount === current ? "active" : "")}><a onClick={() => this.handlePageSelected(allCount)}>{allCount}</a></li>);
                }
            }
        }
        return items;
    }
    handlePageSelected(page) {
        if (page > 0 && page <= this.props.pageCount) {
            this.setState({
                page: page,
                keyIndex: this.state.keyIndex + 1 
            });
            if (this.props.handlePageChange)
                this.props.handlePageChange(page);
        }
    }
    handleChangePageSize(pageSize) {
        this.setState({
            pageSize: pageSize,
            keyIndex: this.state.keyIndex + 1
        });
        if (this.props.handleChangePageSize)
            this.props.handleChangePageSize(pageSize);
    }
}
